<mat-dialog-content>
  <div id="voucher-content" class="voucher-container">
    <h2 mat-dialog-title>Resumen de Orden</h2>
    <p>{{order.business.name}}</p>
    <p>{{ order?.date }}</p>
    <p>{{ order?.table.name }}</p>
    <p>
      Total: {{ order?.totalAmount | currency: 'CLP':'symbol':'1.0-0':'es-CL' }}
    </p>
    <p>Estado: {{ order?.status.description }}</p>

    <div *ngFor="let item of order?.orderDetail" [class.canceled-item]="item.itemStatusSlug === 'canceled'">
      <div class="item-row">
        <span class="item-name">{{ item.menuProduct? item.menuProduct.name : item.product?.name || 'Producto' }}</span>
        <span class="status-badge" [ngClass]="getStatusBadgeClass(item.itemStatusSlug)">
          {{ getStatusLabel(item.itemStatusSlug) }}
        </span>
      </div>
      <div class="text-muted small" *ngIf="getItemOptionNames(item).length">
        {{ getItemOptionNames(item).join(', ') }}
      </div>
      <p class="text-right">
        {{ item.qty }} x {{ item.price | currency:
        'CLP':'symbol':'1.0-0':'es-CL' }} : {{ item.price * item.qty | currency:
        'CLP':'symbol':'1.0-0':'es-CL' }}
      </p>
    </div>

    <p class="total">
      Total a Pagar: {{ order?.totalAmount | currency:
      'CLP':'symbol':'1.0-0':'es-CL' }}
    </p>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="closeDialog()">Cerrar</button>
</mat-dialog-actions>
